/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EquipmentModelVariantResponse { 
    id?: string;
    name?: string | null;
    isActive?: boolean;
    nominalHashrate?: number | null;
    nominalPower?: number | null;
    isAutoDetected?: boolean;
    detectedVia?: string | null;
    source?: string | null;
    detectedAt?: string | null;
    equipmentCount?: number;
}

